// extracted by mini-css-extract-plugin
export default {"modalOverlay":"EditModal_modalOverlay__QhH7n","modal":"EditModal_modal__dcde6","closeButton":"EditModal_closeButton__ewt1k"};